import httpHelper from './http.helper'

const confirmHideDeclaration = ({ vm, tollDeclarationId }) => {
    if (!tollDeclarationId) {
        return
    }

    const notification = {
        title: vm.$t('shared.success'),
        text: vm.$t('correctionHidden'),
    }
    const errorTitle = vm.$t('shared.error')

    vm.$modal.show('dialog', {
        title: vm.$t('warning'),
        text: vm.$t('confirmCorrectionVisibility'),
        buttons: [
            {
                title: vm.$t('shared.yes'),
                handler: async () => {
                    vm.$modal.hide('dialog')
                    try {
                        await vm.hideDeclaration(tollDeclarationId)
                        vm.$notify(notification)
                    } catch (error) {
                        vm.$notify({
                            title: errorTitle,
                            text: httpHelper.parseError(error),
                        })
                    }
                },
            },
            {
                title: vm.$t('shared.no'),
            },
        ],
    })
}

const confirmRevokeDeclaration = ({
    vm,
    declaration,
    notificationTextKey,
    confirmTextKey,
}) => {
    const tollDeclaration = declaration?.toll_declaration

    if (
        !tollDeclaration?.declaration_period ||
        !tollDeclaration?.toll_declaration_id
    ) {
        return
    }

    const notification = {
        title: vm.$t('shared.success'),
        text: vm.$t(notificationTextKey),
    }
    const errorTitle = vm.$t('shared.error')

    vm.$modal.show('dialog', {
        title: vm.$t('warning'),
        text: vm.$t(confirmTextKey),
        buttons: [
            {
                title: vm.$t('shared.yes'),
                handler: async () => {
                    vm.$modal.hide('dialog')
                    try {
                        await vm.revokeDeclaration(declaration)
                        vm.$notify(notification)
                    } catch (error) {
                        vm.$notify({
                            title: errorTitle,
                            text: httpHelper.parseError(error),
                        })
                    }
                },
            },
            {
                title: vm.$t('shared.no'),
            },
        ],
    })
}

export default {
    confirmHideDeclaration,
    confirmRevokeDeclaration,
}
